// HTML ELEMENT CONSTANTS
export const REPORT_TABLE_ID = 'print-mapping-export-table'

// REPORT FIELDS
export const ID = 'id'